<template>
  <div>
    <h1>Projects</h1>
    <div v-if="!isLoaded" id="integrations-container">
      <div v-for="project in projectData.topLevelIssues" :key="project.name">
        <h3>{{ project.name }}</h3>
        <nav>
          <table class="table table-hover tq-text">
            <thead>
              <tr>
                <th scope="col">Id</th>
                <th scope="col">Name</th>
                <th scope="col">Assignee</th>
                <th scope="col">Status</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="issue in project.childIssues" :key="issue.id">
                <td class="col-sm-3 col-md-3 col-lg-3 tq-text" style="width: 200px">
                  <p>
                    {{issue.id}}
                  </p>
                </td>
                <td class="col-sm-3 col-md-3 col-lg-3 tq-text">
                  <p>
                    {{issue.name}}
                  </p>
                </td>
                <td class="col-sm-3 col-md-3 col-lg-3 tq-text" style="width: 150px">
                  <p>
                    {{issue.assignee}}
                  </p>
                </td>
                <td class="col-sm-3 col-md-3 col-lg-3 tq-text" style="width: 150px">
                  <p>
                    {{issue.status}}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </nav>
      </div>


    </div>
        <div class="ph-item" v-if="isLoaded">
          <div class="ph-col-12">
            <div class="ph-row">
              <div class="ph-col-6 big"></div>
              <div class="ph-col-4 empty big"></div>
              <div class="ph-col-2 big"></div>
              <div class="ph-col-4"></div>
              <div class="ph-col-8 empty"></div>
              <div class="ph-col-6"></div>
              <div class="ph-col-6 empty"></div>
              <div class="ph-col-4"></div>
            </div>
          </div>
        </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Project } from "@/models/project";
import ProjectService from "@/services/projectService";
import { getUser } from "@/utils/getUser";

export default Vue.extend({
  data() {
    return {
      projectData: [],
      isLoaded: false
    };
  },
  async created() {
    this.isLoaded = true;
    const jwt = window.localStorage.getItem("jwt");
    if (jwt) {
      const user = getUser();
      const userGroups = user?.groups;
      const projectService = new ProjectService(jwt);
      const response = await projectService.getProjects(userGroups);

      console.log(response.data)
      if (response && response.status == 200) {
        if (response.data) {
            this.projectData = response.data
        }
      }
    }
    this.isLoaded = false;
  }
});
</script>

<style scoped lang="scss">
.tq-card {
  box-shadow: 4px 4px 8px hsla(0, 20%, 80%, 0.2);
  border: 1px solid hsla(0, 20%, 80%, 0.2);

  margin-bottom: 2rem;
  padding: 2rem;

  &:hover {
    box-shadow: 4px 4px 8px hsla(0, 20%, 80%, 0.4);
  }
}

.tq-text {
  h3 {
    font-size: 2rem;
    margin: 1rem 0 0.5rem 0;
  }
  p {
    margin: 0 0 0.5rem 0;
  }
}

h1 {
  border-bottom: 2px solid var(--tq-blue);
  padding-bottom: 8px;
}

table {
  width: 100%;
}

table th {
  text-align: left;
  padding: 8px;
}

table td {
  padding: 8px;
}

table tr {
  width: 100%;
  box-shadow: 4px 4px 8px hsla(0, 20%, 80%, 0.2);
  border: 1px solid hsla(0, 20%, 80%, 0.2);
  margin-bottom: 2rem;
  padding: 2rem;
}

tr:hover {
  box-shadow: 4px 4px 8px hsla(0, 20%, 80%, 0.4);
}
</style>
